import React from 'react'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { ContactPersonalInfoForm, ContactPersonalInfo } from './contact-personal-info-form'
import { makeStyles, Typography } from '@material-ui/core'
import { Address, AddressForm } from './address-form'

export type ContactPerson = {
  personalInfo: ContactPersonalInfo;
  addressInfo: Address;
}

const useStyles = makeStyles({
  paper: {
    margin: '15px',
    padding: '15px'
  }
})

export interface ContactPersonFormProps {
  value: ContactPerson;
  onChange: (person: ContactPerson) => void;
  title: string;
  subtitle: string;
  disabled?: boolean;
}

export const ContactPersonForm: React.FC<ContactPersonFormProps> = function (props) {
  const { value: person, onChange, title, subtitle, disabled = false } = props
  const styles = useStyles()

  function update (key: string, value: any) {
    onChange({
      ...person,
      [key]: value
    })
  }

  return (
    <Paper className={styles.paper}>
      <Typography variant="h5">{title}</Typography>
      <Typography>{subtitle}</Typography>
      <Grid container direction="column" alignItems="stretch">
        <Grid item>
          <Paper className={styles.paper}>
            <Typography variant="h6">Dane osobowe</Typography>
            <ContactPersonalInfoForm disabled={disabled} value={person.personalInfo} onChange={value => update('personalInfo', value)} />
          </Paper>
        </Grid>
        <Grid item>
          <Paper className={styles.paper}>
            <Typography variant="h6">Dane adresowe</Typography>
            <AddressForm value={person.addressInfo} disabled={disabled} onChange={value => update('addressInfo', value)} onErrorChange={() => {}}/>
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  )
}
